import React, { useEffect, useState } from "react";
import MessengerLayout from "../../layout/MessengerLayout";
import ErrorBoundary from "../ui/ErrorBoundary";
import TeamOverviewPanel from "../../components/managerdashboard/TeamOverviewPanel";
import LeaveApprovalPanel from "../../components/managerdashboard/LeaveApprovalPanel";
import AttendanceOverview from "../../components/managerdashboard/AttendanceOverview";
import PerformanceSnapshot from "../../components/managerdashboard/PerformanceSnapshot";
import TicketTrackerPanel from "../../components/managerdashboard/TicketTrackerPanel";

import AlertsAndReminders from "../../components/managerdashboard/AlertsAndReminders";
import InsightsAnalyticsPanel from "../../components/managerdashboard/InsightsAnalyticsPanel";
import QuickManagerActions from "../../components/managerdashboard/QuickManagerActions";

export default function ManagerDashboard() {
  const [managerId, setManagerId] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) setManagerId(user.id);
  }, []);

  if (!managerId) return <div className="text-white p-6">Loading...</div>;

  return (
    <MessengerLayout>
      <div className="p-10 text-white">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <ErrorBoundary variant="panel" label="Team overview"><TeamOverviewPanel managerId={managerId} /></ErrorBoundary>
          <ErrorBoundary variant="panel" label="Alerts & reminders"><AlertsAndReminders managerId={managerId} /></ErrorBoundary>
          <ErrorBoundary variant="panel" label="Quick actions"><QuickManagerActions managerId={managerId} /></ErrorBoundary>
          <ErrorBoundary variant="panel" label="Leave approvals"><LeaveApprovalPanel managerId={managerId} /></ErrorBoundary>
          <ErrorBoundary variant="panel" label="Attendance"><AttendanceOverview managerId={managerId} /></ErrorBoundary>
          <ErrorBoundary variant="panel" label="Performance"><PerformanceSnapshot managerId={managerId} /></ErrorBoundary>
          <ErrorBoundary variant="panel" label="Tickets"><TicketTrackerPanel managerId={managerId} /></ErrorBoundary>
          <ErrorBoundary variant="panel" label="Insights & analytics"><InsightsAnalyticsPanel managerId={managerId} /></ErrorBoundary>
        </div>


      </div>
    </MessengerLayout>
  );
}
